"use client";

import { useEffect } from "react";
import { Property } from "@/lib/types/marketsuite/datatypes/property";
import { trackPropertyViewItem } from "@/lib/data-measurements/property-ecommerce";

interface PropertyViewItemTrackerProps {
	property: Partial<Property>;
}

export function PropertyViewItemTracker({ property }: PropertyViewItemTrackerProps) {
	useEffect(() => {
		trackPropertyViewItem(property);
	}, [property]);

	return null;
}
